<template>
  <main class="content content--narrow">

    <div class="content__heading content__heading--center">
      <figure class="fusebox--emblem">
        <img src="@/assets/svg/fusebox_online_emblem.svg"/>
      </figure>
    </div>

    <section class="content--boxed">
      <ValidationObserver ref="form" #default="{ invalid }" tag="form" @submit.prevent="login">

        <div class="content--boxed__heading">
          <h1>
            <i class="icon--unlock"></i> {{ $t('general.loginToFusebox') }}
          </h1>
        </div>

        <div class="message" v-if="!!stickyMsg">
          {{ stickyMsg }}
        </div>
        <div class="form__wrapper">
          <div class="field__row">
            <Field :label="$t('general.email')"
                   name="email"
                   rules="required|email|max:255"
                   type="email"
                   v-model="form.email"/>
          </div>
          <div class="field__row">
            <Field :label="$t('general.password')"
                   name="password"
                   rules="required"
                   type="password"
                   v-model="form.password"/>
          </div>
          <button class="hidden" type="submit">
            {{ $t('general.login') }}
          </button>

          <div class="btn--bar">
            <button class="btn" :disabled="invalid || submit" @click="login()" type="button">
              {{ $t('general.login') }}
            </button>
            <router-link :to="{ name: 'auth.reset' }" class="btn btn--secondary">{{ $t('general.forgotPassword') }}
            </router-link>

          </div>
        </div>

      </ValidationObserver>
    </section>

    <section class="content--boxed content--boxed--diap">
      <div class="content--boxed__wrapper">
        <div class="content--boxed__heading">
          <h2>
            <i class="icon--unlock"></i> {{ $t('general.noAccount') }}
          </h2>
        </div>
        <div class="content--boxed__body">
          <p v-html="$t('general.loginInfo')"></p>
        </div>
      </div>

      <div class="content--boxed__heading">
        <h2>
          {{ $t('general.createNewAccount') }}
        </h2>
      </div>

      <div class="grid grid--margin">
        <div class="grid__cell grid__cell--1/2">

          <div class="align--center">
            <router-link :to="{ name: 'auth.personal.register' }" class="btn btn--white">{{ $t('general.personal') }}
            </router-link>
          </div>
          <!--          <a class="content__column&#45;&#45;link" href="#">{{ $t('general.personalInfo') }}</a>-->
        </div>
        <div class="grid__cell grid__cell--1/2">

          <div class="align--center">
            <router-link :to="{ name: 'auth.register' }" class="btn btn--white">{{ $t('general.business') }}
            </router-link>
          </div>
          <!--          <a class="content__column&#45;&#45;link" href="#">{{ $t('general.businessInfo') }}</a>-->
        </div>
      </div>

    </section>
  </main>
</template>

<script>
import Field from '@/components/Parts/Field'
import { errHandler } from '@/helpers'

export default {
  components: {
    // Panel,
    Field
  },
  data () {
    return {
      form: {
        email: '',
        password: ''
      },
      submit: false
    }
  },
  computed: {
    stickyMsg () {
      return typeof this.$route.query.sticky !== 'undefined' ? this.$t(`messages.${this.$route.query.sticky}`) : ''
    },
    intended () {
      return typeof this.$route.query.intended !== 'undefined' ? { path: this.$route.query.intended } : { name: 'root' }
    }
  },
  methods: {
    async login () {
      if (await this.$refs.form.validate()) {
        try {
          this.submit = true
          await this.$store.dispatch('auth/login', this.form)
          this.$router.push(this.intended)
        } catch (e) {
          errHandler(e, this.$toasted, key => this.$t(key))
        } finally {
          this.submit = false
        }
      }
    }
  }
}
</script>
